export enum Pillar {
  Chill,
  Do,
  Connect,
  Move,
  Enjoy,
  Celebrate,
  Wellbeing,
}
